export default class AppConstants {
  // Environment variables
  static WEBSOCKET_URL = process.env.VUE_APP_WEBSOCKET_URL;
  static BASE_URL = process.env.VUE_APP_BASE_URL;
  static API_URL = process.env.VUE_APP_API_URL;
}
